import {connect} from 'react-redux'
import {ActionsRow, DetailValue, Loader, modal, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import FirmaForm from "../../forms/ProvozovatelForm";
import {formatTime, timeToDatetime} from "../../utils/utils";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Provozovatel systému
 */
class ProvozovatelPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchFirmaIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
    };

    handleEditFirma = () => {
        const {firmaDetail, zpusobyDopravyList, zpusobyPlatbyList, t} = this.props;

        this.props.dispatch(modal.ModalActions.show(
            FirmaForm,
            {
                onSubmit: (data) => {
                    const newData = {
                        ...data,
                        zobrazovatCasOd: data.zobrazovatCasOd ? timeToDatetime(data.zobrazovatCasOd) : null,
                        zobrazovatCasDo: data.zobrazovatCasDo ? timeToDatetime(data.zobrazovatCasDo) : null,
                    };
                    return CiselnikApi.updateFirma(newData);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateFirma());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    ...firmaDetail.data,
                    zobrazovatCasOd: formatTime(firmaDetail.data.zobrazovatCasOd, null, "HH:mm:ss"),
                    zobrazovatCasDo: formatTime(firmaDetail.data.zobrazovatCasDo, null, "HH:mm:ss"),
                },
                zpusobyDopravyList: zpusobyDopravyList.rows,
                zpusobyPlatbyList: zpusobyPlatbyList.rows,
            },
            t('admin.operator_change'),
            {size: "md"}
        ));
    };

    renderActions = () => {
        const {t} = this.props;
        return <ButtonToolbar>
            <Button onClick={this.handleEditFirma}>{t('edit')}</Button>
        </ButtonToolbar>
    };

    render() {
        const {firmaDetail, t} = this.props;

        let content;
        if (!firmaDetail.fetched) {
            content = <Loader/>;
        } else {
            content = <div>
                <Row>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('operator_name')}>{firmaDetail.data.nazevFirma}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('cin')}>{firmaDetail.data.ic}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('vatin')}>{firmaDetail.data.dic}</DetailValue>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('street')}>{firmaDetail.data.ulice}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('city')}>{firmaDetail.data.obec}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('zip')}>{firmaDetail.data.psc}</DetailValue>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('phone')}>{firmaDetail.data.telefon}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('email')}>{firmaDetail.data.email}</DetailValue>
                    </Col>
                    <Col xs={4}>
                        <DetailValue textOverflow label={t('web_page')}>{firmaDetail.data.www}</DetailValue>
                    </Col>
                </Row>
            </div>;
        }

        return <AdminPage
            title={t('admin.system_operator')}
            subtitle={t('admin.system_operator')}
            content={
                <Card className="zakladni-udaje-panel">
                    <CardHeader>
                        <ActionsRow actions={this.renderActions()}>
                            <h2>{t('basic_details')}</h2>
                        </ActionsRow>
                    </CardHeader>
                    <CardBody>
                        {content}
                    </CardBody>
                </Card>
            }
        />
    }
}

function mapStateToProps(state) {
    return {
        firmaDetail: utils.storeFromArea(state, ciselnikActions.FIRMA_AREA),
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(ProvozovatelPage));

